// covered-by: frontends/carrie/src/ask-v2/home/__tests__/visibleActions.test.ts
import {
  type AskPunttActionCard,
  type AskPunttBriefing,
} from "@mg/schemas/src/christo/askPunttBriefing";

/** One Not Now → silent. Badge is a count, not a stack. Never invent cards. */
export function visibleActions(
  briefing: AskPunttBriefing | undefined,
): AskPunttActionCard[] {
  if (!briefing || briefing.dismissed) return [];
  if (briefing.interruptPolicy !== "card") return [];
  return briefing.actions;
}

export function waitingBadgeCount(
  briefing: AskPunttBriefing | undefined,
): number {
  if (!briefing || briefing.dismissed) return 0;
  if (briefing.interruptPolicy !== "badge") return 0;
  return briefing.actions.length;
}
